module.exports = __webpack_public_path__ + "img/bullet-star.6ef4eb19.svg";